export enum INCOME_SUBGROUP_CATEGORY {
  PRODUCT_INCOME = 'PRODUCT_INCOME',
  EXPORT_INCOME = 'EXPORT_INCOME',
  OTHER_OPERATION_INCOME = 'OTHER_OPERATION_INCOME',
  OTHER_NON_OPERATION_INCOME = 'OTHER_NON_OPERATION_INCOME',
}

export enum INCOME_CATEGORY_TOPIC {
  TOTAL_REVENUE_FROM_OPERATIONS = 'รายได้จากการดำเนินงานรวม',
  OTHER_OPERATING_INCOME = 'อื่น ๆ',
  TOTAL_REVENUE = 'รายได้รวม',
  DOMESTIC_REVENUE = 'รายได้จากในประเทศ',
  INTERNATIONAL_REVENUE = 'รายได้จากต่างประเทศ',
  OTHER_COUNTRIES_REVENUE = 'ประเทศอื่น ๆ',
  TOTAL_OTHER_INCOME = 'รายได้อื่นรวม',
  OTHER_INCOME_FROM_OPERATIONS = 'รายได้อื่นจากการดำเนินงาน',
  OTHER_INCOME_NOT_FROM_OPERATIONS = 'รายได้อื่นนอกเหนือจากการดำเนินงาน',
  SHARE_OF_PROFIT = 'ส่วนแบ่งกำไร (ขาดทุน)',
}

export enum TOTAL_INCOME_STRUCTURE_ID {
  TOTAL_PRODUCT_INCOME = 1,
  TOTAL_EXPORT_INCOME = 3,
  TOTAL_OTHER_INCOME = 7,
}

export enum OTHER_INCOME_STRUCTURE_ID {
  OTHER_PRODUCT_INCOME = 2,
  OTHER_EXPORT_INCOME = 5,
}

export enum OTHER_INCOME_TYPE_ID {
  OPERATIONS = 8,
  NON_OPERATIONS = 9,
  SHARE_PROFIT = 10,
}

export enum EXPORT_INCOME_TYPE_ID {
  DOMESTIC = 4,
  INTERNATIONAL = 6,
}
